import { useEffect, useState } from "react";
import { AUTH_STORAGE_KEY } from "../..//api/authService/supabase";
const BETA_ACCESS_KEY = 'bottom-up-beta-access';

const getBetaAccessKey = () => {
    if (typeof window === 'undefined') return BETA_ACCESS_KEY;
    
    const auth = localStorage.getItem(AUTH_STORAGE_KEY)
    if (auth) {
        const authObj = JSON.parse(auth)
        return BETA_ACCESS_KEY +'-' + authObj?.user?.id
    }
    return BETA_ACCESS_KEY
}

export const useBetaAccess = (): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
    const betaAccessKey = getBetaAccessKey();
    const localBetaAccess = typeof window !== 'undefined' ? localStorage.getItem(betaAccessKey) : 'true';
    const [isBetaAccess, setIsBetaAccess] = useState(true);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            localStorage.setItem(betaAccessKey, isBetaAccess?.toString());
        }
    }, [isBetaAccess, betaAccessKey])

    return [ isBetaAccess, setIsBetaAccess ];
};